import { UserPassword } from 'client/voladeum/auth/types';

export const user_password_default: UserPassword = { password: '' };
